var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px", "text-align": "center" },
          attrs: { "align-h": "center" }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("font-awesome-icon", {
                staticClass: "text-success my-auto success-icon",
                attrs: { icon: ["fas", "check-circle"] }
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "font-weight-bolder mt-3" }, [
                _vm._v("Payment Successful!")
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-bottom": "55px" } }, [
                _vm._v("Thank you")
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-primary btn-block",
                  attrs: {
                    href: _vm.getFromApps
                      ? "musicverse://transaction_done"
                      : "/#/home"
                  }
                },
                [_vm._v("Continue")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92f11702", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f11702","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TransactionSuccess.vue
// module id = null
// module chunks = 